var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topic_main"},[_c('head-top',{attrs:{"head-title":"发表话题","topic-publish":"发布","goBack":"true"},on:{"topicPublish":_vm.addTopic}}),_vm._v(" "),_c('publish',{attrs:{"holder":_vm.holder},on:{"getValue":_vm.getValue,"getImage":_vm.getImage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ac891ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/message/Topic.vue
// module id = s03C
// module chunks = 0